import React from "react";

export type AppConfig = {
  assignementsAPI: string;
  version?: string;
};

export const AppConfigContext = React.createContext<AppConfig | undefined>(undefined);

export function isValidAppConfig(appConfig: any): appConfig is AppConfig {
  return appConfig.assignementsAPI !== "";
}
